export default "__VITE_ASSET__6ccefcc2__"